<template>
  <div class="container mescroll-touch">
    <div class="borderTop"></div>
    <div class="contentBox">
      <img class="nolive" src="@/assets/images/noLive.png" />
      <p class="tips">直播尚未上架<br/>本次直播还未上架，请返回查看其他直播活动</p>
      <div class="goback" @click="$router.push('/liveList?id=0')">返回</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoLive',
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.container{
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  background-color: #F9F8F7;
  .borderTop {
    width: 100%;
    height: 10px;
    background-color: #EB1700;
  }
  .contentBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    .nolive {
      display: block;
      width: 60%;
      margin: 0px auto 20px;
    }
    .tips {
      text-align: center;
      color: #606060;
      font-size: 13px;
      line-height: 20px;
    }
    .goback {
      width: 100px;
      height: 36px;
      line-height: 36px;
      border-radius: 36px;
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      color: #FFFFFF;
      background-image: url('../../assets/images/btn_bg1.png');
      background-size: 100% 100%;
      margin: 40px auto 0;
    }
  }
}
</style>